<template>
  <div class="article-content-body col-9 p-0">
    <div
      class="title col-12"
      :data-title="$t('label.title')"
      :data-char="title.length"
      :data-char-max="maxTitleLength"
    >
      <input
        type="text"
        class="form-control"
        name="title"
        v-model="title"
        v-validate="'required'"
        :class="{ error: errors.has('title') }"
        :maxlength="maxTitleLength"
        :placeholder="$t('label.title')"
        :disabled="!canUpdateContent"
        @keyup="updateContents"
      />
    </div>
    <div class="desc col-12" :class="{ error: errors.has('content') }">
      <input
        type="hidden"
        name="content"
        v-validate="'required|min_value:2'"
        v-model="contentLength"
      />
      <div ref="editor" class="editor" :disabled="!canUpdateContent"></div>
    </div>
  </div>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.snow.css";

export default {
  props: ["articleId", "articleTitle", "articleBodyJson", "canUpdateContent"],
  data() {
    return {
      articleType: this.$route.params.articleType,
      contentJson: null,
      contentHtml: "",
      contentLength: 0,
      maxTitleLength: 80,
      title: ""
    };
  },
  watch: {
    articleTitle(newValue, oldValue) {
      if (!this.title || newValue != oldValue) {
        this.title = newValue;
      }
    },
    articleBodyJson(newValue, oldValue) {
      if (!this.contentJson || newValue != this.contentJson) {
        this.contentJson = newValue;
        this.editor.setContents(this.contentJson);
        this.getContents();
        this.created();

        this.editor.on("text-change", () => {
          this.getContents();
          this.updateContents();
        });
      }
    }
  },
  mounted() {
    const container = this.$refs.editor;
    this.editor = new Quill(container, {
      theme: "snow",
      formats: ["header", "bold", "underline", "link", "blockquote"],
      modules: {
        toolbar: [
          [{ header: 1 }, { header: 2 }],
          ["bold", "underline"],
          ["blockquote", "link"]
        ],
        keyboard: {
          bindings: {
            tab: {
              key: 9,
              handler: () => false
            }
          }
        },
        clipboard: {
          matchVisual: false
        }
      },
      placeholder: "เริ่มพิมพ์ที่นี่"
    });

    if (!this.articleId) {
      this.editor.on("text-change", () => {
        this.getContents();
        this.created();
      });
    }
  },
  methods: {
    created() {
      this.$emit("created", {
        title: this.title,
        content: this.contentHtml,
        contentJson: this.contentJson
      });

      if (!this.canUpdateContent) {
        this.editor.enable(false);
      }
    },
    getContents() {
      this.contentJson = this.editor.getContents();
      this.contentLength = this.editor.getLength();
      this.contentHtml = this.editor.container.firstChild.innerHTML;
    },
    updateContents() {
      this.$emit("edited", {
        title: this.title,
        content: this.contentHtml,
        contentJson: this.contentJson
      });
    },
    async validate() {
      this.contentLength = this.editor.getLength();

      const result = await this.$validator.validate();
      this.$emit("validate", result);
      return result;
    }
  }
};
</script>

<style lang="scss">
#article-create {
  .editor {
    overflow-y: scroll;
    max-height: calc(100vh - 400px);
  }

  .error .ql-editor.ql-blank::before {
    color: $red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/create/ContentDetailBody.vue